import React, { useEffect, useState } from "react";
import "./TextContents.css";
import Partners from "./Partners";
import INSTARGRAM from "../assets/imgs/icn-instagram.svg";
import FACEBOOK from "../assets/imgs/icn-facebook.svg";
import ParallaxSection from "./sections/ParallaxSection";
import OurVision from "./sections/OurVision";
import OurStory from "./sections/OurStory";
import Itineraries from "./Itineraries";
import Experiences from "./Experiences";
import { useTranslation } from "react-i18next";

const SECTION_BASE = "px-[10vw] py-[4vw] md:px-[10px] md:py-[10vh] flex flex-col justify-center snap-start";

const TextContent = ({
  sectionMovie,
  sectionService,
  sectionStory,
  sectionOurTeam,
  sectionVision,
  sectionPartners,
  sectionGallery,
  sectionExperiences,
  sectionCompanyInfo,
  gotoCompanyInfo
}) => {

  const { t } = useTranslation();

  const [position, setPosition] = useState(0);
  const [visionTranslateY, setVisionTranslateY] = useState(200);

  useEffect(() => {
    const id = setInterval(() => {
      if (position >= 2800 && visionTranslateY >= 0) {
        setVisionTranslateY(moveY => moveY - 1.0);
      }
    }, 0.2);
    return () => clearInterval(id);
  }, [position, visionTranslateY]);

  function onScroll() {
    setPosition(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const targetElements = document.querySelectorAll(".fade-wrap");
    targetElements.forEach((element) => {
      observer.observe(element);
    });

    const header = document.querySelector("header");

    handleScroll();

    function handleScroll() {
      if (window.scrollY > 0) {
        header?.classList.add("on");
      } else {
        header?.classList.remove("on");
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll)

      targetElements.forEach((element) => {
        observer.unobserve(element);
      });

      observer.disconnect();
    };
  }, []);

  return (
    <div id="header" className="text__container font-[Paperozi] snap-y snap-mandatory">
      <div className="about pt-[0pt] md:px-0 min-h-screen snap-start" ref={sectionMovie}>
        <div className="flex relative h-screen" style={{ opacity: (900 - position) / 900 }}>
          <ParallaxSection gotoCompanyInfo={gotoCompanyInfo} />
        </div>
      </div>

      <div className={`${SECTION_BASE} overflow-hidden fade-wrap mt-[100px]`} ref={sectionService}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          KOREA TRAVEL STORE
        </p>
        <div className="flex flex-row gap-2 font-bold mb-5 text-start text-[40px] md:text-[24px]">
          <h1 className="text-[#028CBB]">
            {t("section1.title")}
          </h1>
          <h1 className="text-[#F5A616]">KTS</h1>
        </div>
        <div className="flex flex-col text-justify text-black text-[17px] md:text-[14px] gap-2">
          <div>{t("section1.param1")}</div>
          <div>{t("section1.param2_1")} <span className="text-[#F5A616] font-bold">{t("section1.param2_2")}</span> {t("section1.param2_3")} <span className="text-[#F5A616]">{t("section1.param2_4")}</span> {t("section1.param2_5")}</div>
          <div>{t("section1.param3_1")} <span className="text-[#F5A616]">{t("section1.param3_2")}</span>{t("section1.param3_3")}</div>
          <div>{t("section1.param4")}</div>
          <div>{t("section1.param5")}</div>
        </div>
      </div>

      <div className={`${SECTION_BASE} itineraries`} ref={sectionGallery}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          {t("section5.title")}
        </p>
        <Itineraries />
      </div>

      <div className={`${SECTION_BASE} itineraries`} ref={sectionExperiences}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          Experiences
        </p>
        <Experiences />
      </div>

      <div className={`${SECTION_BASE} overflow-hidden fade-wrap`} ref={sectionService}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          {t("section2.title")}
        </p>
        <Partners />
      </div>

      <div className={SECTION_BASE} ref={sectionStory}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          {t("section3.title")}
        </p>
        <OurStory />
      </div>

      <div className={`${SECTION_BASE} our__vision text-start`} ref={sectionVision}>
        <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
          {t("section4.title")}
        </p>
        <OurVision />
      </div>

      <div className="flex flex-col text-start bg-[#191F28] text-[13px] text-[#8b95a1] md:p-6 p-10 gap-2 snap-start" ref={sectionCompanyInfo}>
        <div className="pt-2 pb-2">
          <p className="text-[20px] font-bold tracking-[0.18em] uppercase text-gray-400 mb-8 text-start">
            Contact US
          </p>

          <div className="grid md:grid-cols-1 grid-cols-2 gap-x-10 gap-y-2 mb-4">

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Registration</span>
              <span>631-81-03232</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Tel</span>
              <span>+82-2-828-8600</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">CEO</span>
              <span>Taylor Kim, Allen Yoo</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Fax</span>
              <span>+82-2-2216-7347</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Sales</span>
              <span>Davide Tognaccini</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Official</span>
              <span className="break-all">koreatravelstore@gmail.com</span>
            </div>

            <div className="grid grid-cols-[90px_1fr] gap-2 text-xs text-gray-500">
              <span className="text-[11px] font-medium text-gray-400">Contact</span>
              <span className="break-all">davide.kts2@gmail.com</span>
            </div>

          </div>

          <div className="text-[11px] text-gray-400 pt-3">
            Unit 1111, 15-1, Gukhoe-daero 70-gil Yeongdeungpo-gu, Seoul, Republic of Korea
          </div>

          <div className="text-[#B0B8C1] text-[15px] mb-4">KOREATRAVELSTORE Co.,Ltd</div>

          <div className="flex flex-row select-none gap-2">
            <a target="_blank" href="https://www.facebook.com/Koreatravelstore/" rel="noreferrer">
              <img src={FACEBOOK} alt="Toss Facebook" />
            </a>
            <a target="_blank" href="https://www.instagram.com/koreatravelstore/" rel="noreferrer">
              <img src={INSTARGRAM} alt="Toss Instagram" />
            </a>
          </div>
        </div>
      </div>
    </div >
  );
};

export default TextContent;